export default "__VITE_ASSET__qgLu2J0z__"